export namespace StringUtils {
  export function capitalise(text: string): string {
    if (text.length === 0) {
      return text;
    }

    return text[0].toUpperCase() + text.substr(1);
  }

  export function replaceAll(
    text: string,
    find: string,
    replace: string
  ): string {
    while (text.indexOf(find) >= 0) {
      text = text.replace(find, replace);
    }

    return text;
  }

  export function replaceFirstToken(
    text: string,
    tokens: string[],
    replace: string,
    replacementFormats: string[]
  ): string {
    let earliestIndex = 1000000;
    let earliestToken = "";
    let tokenIndex = -1;

    tokens.forEach((token, index) => {
      const thisIndex = text.indexOf(token);
      if (thisIndex >= 0 && thisIndex < earliestIndex) {
        earliestIndex = thisIndex;
        earliestToken = token;
        tokenIndex = index;
      }
    });

    if (earliestToken.length > 0) {
      return text.replace(
        earliestToken,
        replaceAll(replacementFormats[tokenIndex], "$", replace)
      );
    }

    return text;
  }

  export function splitFirst(text: string, token: string): string[] {
    const index = text.indexOf(token);

    if (index < 0) {
      return [text];
    }

    return [text.substr(0, index + 1), text.substr(index + token.length)];
  }

  export function unescapeXmlChars(text: string): string {
    return replaceAll(text, "&amp;", "&");
  }
}



// WEBPACK FOOTER //
// ./utils/StringUtils.ts